export const getSuperbillFlowId = state => state.superbillFlows.superbillFlow.id;
export const getSuperbillFlowData = state => state.superbillFlows.superbillFlow;
export const superbillFlowIsFetching = state => state.superbillFlows.loading;